import React, { useState, useContext, useEffect } from 'react'
import { Paper } from '@mui/material'
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';
import api from '../../API/api';
import axios from 'axios'

function RaggingForm(props) {

    const { schools } = useContext(SchoolContex);

    // console.log(schools, 'school');

    const [file, setFile] = useState();
    const [courses, setCourses] = useState();
    const [data, setData] = useState({
        reg_no: '',
        ref_no: '',
        school_id: '',
        course_id: '',
    });

    function handleInput(e) {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }
    function handleInputFile(e) {
        setFile(e.target.files[0])
    }
    function handleSchoolChange(e) {
        // console.log(e, 'tajes e');
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
        if (e.target.value) {
            getCourses(e.target.value);
        }
    }
    const getCourses = (id) => {
        api.getCourses(id).then((res) => {
            // console.log(res);
            setCourses(res.data.courses)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }

    function submitForm() {
        const postData = new FormData();

        if (data.school_id == '' || data.school_id == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'School Cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (data.course_id == '' || data.course_id == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Course Cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        if (data.reg_no == '' || data.reg_no == undefined) {
            Swal.fire({
                title: 'Error!',
                text: 'Registration no Cannot be blank',
                icon: 'error',
                confirmButtonText: 'Ok'
            })
            return;
        }
        // console.log(data);
        // return;
        postData.append('reg_no', data.reg_no)
        postData.append('ref_no', data.ref_no)
        postData.append('school_id', data.school_id)
        postData.append('course_id', data.course_id)
        postData.append('image', file)
        
        //   return;
        axios.post(`${process.env.REACT_APP_MAIN_API}saveAntiRaging`, postData)
            .then(res => {
                // console.log(res, 'check res');
                if (res.data.status === 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: res.data.message,
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    })

                    props.handleClose();
                }
                if (res.data.status === 400) {
                    Swal.fire({
                        title: 'Opps!',
                        text: res.data.message,
                        icon: 'warning',
                        confirmButtonText: 'Ok'
                    })
                }


            }).catch(err => {
                // console.log(err, 'asdvbsahdb');
            })
    }


    // useEffect(() => {
    //     console.log(data,'data');
    // },[data])

    return (
        <div className='ragging-form'>
            <h3>Anti Ragging </h3>
            <div className='row'>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Registration No: ( <a href='/RegisterStudent'> Not Registered yet? </a>)</label>
                    <input type="text" className='form-control' value={data.reg_no} name="reg_no"
                        onChange={handleInput} />
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor=""> Reference no :</label>
                    <input type="text" className='form-control' value={data.ref_no} name="ref_no"
                        onChange={handleInput} />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">School Name:</label>
                    <select className='form-select' onChange={handleSchoolChange} value={data.school_id} name="school_id">
                        <option > ---select from Below---</option>
                        {
                            schools?.map((item, index) => (
                                <>
                                    <option key={index} value={item.id}>{item.schoolName}</option>
                                </>
                            ))
                        }
                    </select>
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Course:</label>
                    <select className='form-select' onChange={handleSchoolChange} value={data.course_id} name="course_id">
                        <option > ---select from Below---</option>
                        {
                            courses?.map((item, index) => (
                                <>
                                    <option key={index} value={item.id}>{item.courseName}</option>
                                </>
                            ))
                        }
                    </select>
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Image :</label>
                    <input type="file" className='form-control' name="image"
                        onChange={handleInputFile} />
                </div>
            </div>
            <div className='text-center mt-3'>
                <button className='btn btn-primary' type='button' onClick={submitForm}>Submit </button>
            </div>
        </div>
    )
}

export default RaggingForm